import { nanoid } from 'nanoid';
import { useEffect, useState } from 'react';
import { Link, Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import {
  LoadingSpinner,
  Header,
  SigninModal,
  useAlert,
  useAuthUser,
  useCurrentCompany,
} from '@employ-engage/common-components';
import { useTranslation } from 'react-i18next';
import { AuthStatusEnum } from '@employ-engage/data';

export const NonAccountUserRoutes = () => {
  const { user, signout, status } = useAuthUser();
  const navigate = useNavigate();
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const [signupMode, setSignupMode] = useState<'signup' | 'signin'>('signin');
  const [logoutTrigger, setLogoutTrigger] = useState(false);
  const { t } = useTranslation(['common']);
  const { currentCompany } = useCurrentCompany();
  const { Alert, fireAlert } = useAlert({
    type: 'error',
    message: t('There was an error'),
  });
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('alert-message')) {
      fireAlert(5000);
    }
    if (searchParams.get('signin') === 'true') {
      setIsSignInModalOpen(true);
    }
    if (searchParams.get('signup') === 'true') {
      setIsSignInModalOpen(true);
      setSignupMode('signup');
    }
  }, [searchParams]);

  useEffect(() => {
    if (searchParams?.get('signin') === 'true') {
      setIsSignInModalOpen(true);
    }
  }, [searchParams]);

  const onClickLogout = () => {
    signout()
      .then(() => {
        setLogoutTrigger((prev) => !prev); // Toggle the state to trigger re-render
        navigate('/', { state: nanoid() });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    // do nothing. this is just to trigger a rerender
  }, [logoutTrigger]);

  return (
    <div>
      <Header
        onLogoClickGoHome
        isMultiLanguageEnabled
        rightSide={
          status === AuthStatusEnum.Pending ? (
            <LoadingSpinner spinnerId="non-account-user-routes-loading" />
          ) : user ? (
            <div>
              <span className="mx-4">{user.email}</span>
              <Link
                to={`/${currentCompany.friendlyCompanyId}/admin`}
                className="mr-4"
              >
                {t('Admin_Console')}
              </Link>
              <button onClick={onClickLogout}>{t('Logout')}</button>
            </div>
          ) : (
            <button
              onClick={() => setIsSignInModalOpen(true)}
              className="bg-dark-primaryBackground hover:bg-dark-primaryBackground px-3 py-2 sm:px-5 sm:py-3 rounded text-white text-sm sm:text-md"
            >
              {t('Admin Login')}
            </button>
          )
        }
      />
      <div className="px-7 sm:px-14">
        <Outlet />
        <SigninModal
          open={isSignInModalOpen}
          setOpen={setIsSignInModalOpen}
          signupMode={signupMode}
          setSignupMode={setSignupMode}
        />
        <Alert message={searchParams.get('alert-message') as string} />
      </div>
    </div>
  );
};

export default NonAccountUserRoutes;
